import { useMemo } from 'react';
import { useNavMenuItems } from '../../../hooks/useNavMenuItems';
import { useSettingsNavRoutes } from '../../../routes/Settings/SideNavBar/settingsNav';
import { useAuth } from '../../../services/auth0';
import {
  CommandPaletteItem,
  CommandPaletteItems,
} from './commandPalette.types';
import {
  buildSettingsCommandItems,
  EXTRA_NAV_ITEMS,
} from './commandPalette.utils';

export type { CommandPaletteItem, CommandPaletteItems };

export const useCommandPaletteItems = (): CommandPaletteItems => {
  const { currentTenantUserHasRole } = useAuth();
  const menuItems = useNavMenuItems();
  const settingsNavRoutes = useSettingsNavRoutes();

  return useMemo(() => {
    const navItems: CommandPaletteItem[] = menuItems
      .filter(({ hidden, roles }) => !hidden && currentTenantUserHasRole(roles))
      .map(({ label, icon, to }) => ({
        id: `nav-${label}`,
        label,
        description: '',
        category: 'Navigation',
        route: to,
        icon,
      }));

    const extraItems = EXTRA_NAV_ITEMS.filter(({ roles }) =>
      currentTenantUserHasRole(roles),
    ).map(({ id, label, route, icon }): CommandPaletteItem => ({
      id,
      label,
      description: '',
      category: 'Navigation',
      route,
      icon,
    }));

    const settingsItems = buildSettingsCommandItems(settingsNavRoutes);

    return { navItems, items: [...navItems, ...extraItems, ...settingsItems] };
  }, [currentTenantUserHasRole, menuItems, settingsNavRoutes]);
};
